import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import { FormattedMessage } from 'react-intl';

type IntroProps = {
    userHasBooked: boolean;
    setShowContactDialog: (show: boolean) => void;
};

export const Intro = ({ userHasBooked, setShowContactDialog }: IntroProps) => {
    return (
        <div className='flex-1-1-0 padding-top-20 margin-top-3 min-width-400-sm'>
            <h1 className='margin-bottom-25'>
                <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.welcome.intro.header'} />
            </h1>
            <p className='text-size-18 text-medium'>
                <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.welcome.intro.subheader'} />
            </p>
            <p className='text-size-18 margin-bottom-15'>
                <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.welcome.intro.description'} />
            </p>
            <ButtonToolbar className='gap-20'>
                <Button
                    bsStyle='default'
                    iconName='rioglyph-support'
                    autoTrackingKey='intl-msg:ordercom-cloud-frontend.help.button'
                    onClick={() => setShowContactDialog(true)}
                >
                    <FormattedMessage id='intl-msg:ordercom-cloud-frontend.help.button' />
                </Button>
                {!userHasBooked && (
                    <Button
                        bsStyle='primary'
                        iconName='rioglyph-arrow-right'
                        iconRight
                        autoTrackingKey='intl-msg:ordercom-cloud-frontend.book-now.button'
                        onClick={() => {
                            window.location.href = 'https://rio.cloud/en/marketplace/overview';
                        }}
                    >
                        <FormattedMessage id='intl-msg:ordercom-cloud-frontend.book-now.button' />
                    </Button>
                )}
            </ButtonToolbar>
        </div>
    );
};
